// Copyright (c) 2023 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import {LoadDataModalFactory, withState} from '@kepler.gl/components';
import {LOADING_METHODS} from '../constants/default-settings';

// import { CustomFileUploadFactory } from './CustomFileUploadFactory';

import { loadRemoteMapWithConfig, loadSessionMap} from '../actions';
import LoadFileContainer from '../components/load-data-modal/load-file-container';
import LoadSessionContainer from '../components/session-modal/load-session-container';

// Get the actual component from the factory
// const CustomFileUpload = CustomFileUploadFactory(/* dependencies here */);

const CustomLoadDataModalFactory = (ModalTabs, LoadStorageMap, ...deps) => {
  const LoadDataModal = LoadDataModalFactory(ModalTabs, LoadStorageMap, deps);
  const additionalMethods = {
    explorer: {
      id: LOADING_METHODS.explorer,
      label: 'modal.loadData.explorer',
      elementType: LoadFileContainer
    },
    session: {
      id: LOADING_METHODS.session,
      label: 'modal.loadData.session',
      elementType: LoadSessionContainer
    }
  };

  LoadDataModal.defaultProps = {
    ...LoadDataModal.defaultProps,
    loadingMethods: [
      additionalMethods.explorer,
      additionalMethods.session,
    ],
  };

  return withState([], state => ({...state.demo.app, ...state.demo.keplerGl.map.uiState, isCloudMapLoading: state.demo.app.isMapLoading}), {
    onLoadSessionMap: loadSessionMap,
    onLoadRemoteMapWithConfig: loadRemoteMapWithConfig
  })(LoadDataModal);
};

CustomLoadDataModalFactory.deps = LoadDataModalFactory.deps;

export function replaceLoadDataModal() {
  return [LoadDataModalFactory, CustomLoadDataModalFactory];
}
